import {Observable} from 'rxjs';

import {combineEpics} from 'web-app/util/redux-observable';

import * as Actions from './actions';
import * as Api from './api';

const fetchReport = action$ =>
    action$.ofType(Actions.fetchReport.type).mergeMap(({payload}) =>
        Api.fetchReport(payload.institutionId)
            .map(response => Actions.fetchReportSuccess.action(response))
            .catch(e => Observable.of(Actions.fetchReportFailed.action(e))),
    );

export default combineEpics(fetchReport);
